import React from "react";
import { motion } from "framer-motion";
import { ShieldAlert, Clock, Layers, Hash } from "lucide-react";

export default function SaboteurIntro({ onStart }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="flex flex-col items-center justify-center py-8 px-2"
    >
      <div className="max-w-xl w-full text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold mb-8"
          style={{ background: "#B0FCEA", color: "#00664C", border: "1px solid #61E8C6" }}>
          <ShieldAlert className="w-4 h-4" />
          Teste de Sabotadores
        </div>

        <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: "Poppins, sans-serif", lineHeight: 1.2, color: "#003326" }}>
          Descubra o que<br />
          <span style={{ color: "#00DCA4" }}>te trava</span>
        </h1>

        <p className="text-lg mb-10" style={{ color: "#646C6F" }}>
          Baseado no framework de Inteligencia Positiva, este teste identifica os padroes internos que bloqueiam seu crescimento profissional na economia digital.
        </p>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 mb-10">
          {[
            { icon: Clock, label: "6 minutos", sub: "para completar" },
            { icon: Layers, label: "10 sabotadores", sub: "analisados" },
            { icon: Hash, label: "35 perguntas", sub: "Likert 1-5" },
          ].map((s, i) => (
            <div key={i} className="rounded-2xl p-4 text-center bg-white"
              style={{ border: "1px solid #E5E9EA" }}>
              <s.icon className="w-5 h-5 mx-auto mb-2" style={{ color: "#00DCA4" }} />
              <p className="font-bold text-sm" style={{ color: "#003326" }}>{s.label}</p>
              <p className="text-xs mt-0.5" style={{ color: "#99A6AB" }}>{s.sub}</p>
            </div>
          ))}
        </div>

        <button
          onClick={onStart}
          className="w-full py-4 rounded-2xl text-base font-bold transition-all duration-200 hover:scale-[1.02]"
          style={{ background: "#00DCA4", color: "#003326" }}
        >
          Iniciar teste
        </button>

        <p className="text-xs mt-4" style={{ color: "#99A6AB" }}>
          Nao ha respostas certas ou erradas. Responda com honestidade.
        </p>
      </div>
    </motion.div>
  );
}
